module.exports = __webpack_public_path__ + "static/media/vf-button-men-shoes.3136bf60.svg";